import React, { FC } from 'react';
import ClassificationRunDialog from './ClassificationRunDialog';

const SuperUserPanel: FC = () => (
  <div className="page-container">
    <h1 className="page-header">Super User Panel</h1>
    <div className="page-card" style={{ padding: 24 }}>
      <ClassificationRunDialog />
    </div>
  </div>
);

export default SuperUserPanel;
